import type { OrderingLedger } from '../machines/ordering-machine.types';

/**
 * Given a ledger, return the maximum tip amount that can be applied to the order.
 */
export const getMaxTipAmount = (ledger?: OrderingLedger) => {
  return ledger?.subtotal ?? 0;
};
